import React from 'react';
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
// import moment from "moment";
// import "moment/locale/ko";
// import 'react-dates/initialize';
// import { SingleDatePicker } from 'react-dates';
// import 'react-dates/lib/css/_datepicker.css';
import DaumPostcode from 'react-daum-postcode';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import SelectDropDownBtn from '../common/button/SelectDropDownBtn';
import NormalInput from '../common/input/NormalInput';
import TextArea from '../common/textarea/TextArea';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ko from 'date-fns/locale/ko';

import { isMobileOnly } from 'react-device-detect';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import { DeCryptData } from '../../lib/util/CustomUtil';
import ReqFormQuestion from '../req/ReqFormQuestion'
import { remove, findIndex, forEach, find } from 'lodash';
import CheckBtn from '../common/button/CheckBtn';
import { Redirect, useHistory } from 'react-router-dom';

registerLocale('ko', ko);


const daumModalStyles = {
    content: isMobileOnly ? {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: '90vh',
        zIndex: '999',

    } : {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '999',
        },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }

};

const CustomInputIcon = ({ onClick }) => (
    <div
        style={{
            width: "28px",
            height: "28px",
            backgroundImage: `url(/assets/images/icon/calendar-icon.png)`
        }}
        onClick={onClick}
    />
);


const SrMyCartDvryCompBlock = styled.div`
${isMobileOnly && `
  .address-finder {
    display:flex;
    margin-bottom:10px;
    button {width:110px; height:40px; font-size:13px;}
    input {width:100%;}
   }
   

.delivery-input-item {
  display:flex;
  justify-content:space-between;

  .double_btn-box {    
    &.w50 {width: 50% }
    &.w100 {width: 100%;}
    button{
      width: calc( 50% - 10px );
      margin-right: 10px;
      height: 40px;
      border: 1px solid #ccc;
      
      background-color: transparent;
      color: #999;
      font-size: 14px;
      border-radius: 4px;

      &.active {
        color: #333;
        background-color: #fddb87;      
      }    
    }
  }
  .select-box {flex:1;}
  
}
`}

    .item-input2 {
        padding: 0 15px 0 15px;
    }
`;

const DatepickerBlock = styled.div`

  ${isMobileOnly && `
    &, 
    & > div.react-datepicker-wrapper, 
    & > div > div.react-datepicker__input-container,
    & > div > div.react-datepicker__input-container input {
       width: 92vw;
    }
    `};

    ${!isMobileOnly&&`
        float: left;
        width: 166px;  
    `};

    .CalendarDay {
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        vertical-align: middle
    }

    .CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
        background: #ffc742;
        border: 1px solid #ffc742;
        color: #fff;
    }

    .SingleDatePickerInput {
        border-radius: 4px;
        border: 1px solid #ccc;
        font-size: 14px;
        padding: 5px;
        height: 40px;
        vertical-align: middle;
    }

    .SingleDatePickerInput__withBorder {
        border: 1px solid  ${props => props.focused ? '#ffc742' : '#dbdbdb'};
        height: 40px;
        padding: 0px 5px 0px;
    }

    .DateInput_input {
        padding: 0px;
        vertical-align: middle;
        font-size: 14px;
    }
    .DateInput_input__focused {
        border-bottom: 0px;
    }

    .SingleDatePickerInput_calendarIcon {
        padding: 5px;
    }

`;

const InfoPopOverBlock = styled.span`
      .accent {font-weight: bold;}
      
      .fa-exclamation-circle {
          position:relative;
        .info-concurrency {
          display:none; 
          position:absolute;
          background-color:#fff; 
          border:1px solid #999; 
          animation: fadeOut ease 2s;
          left: -88px;
          min-width: 408px;
          top: 36px;
          //width:100%;
          padding:30px; 
          text-align: left;
          border-radius: 4px;
          ${isMobileOnly&&`top: 23px; left: -71px;`};
          ${isMobileOnly&&`min-width: 78vw; right: 5vw; padding: 15px;`};
          z-index: 99;
            .title {
                font-size: 18px;
                ${isMobileOnly&&`font-size: 16px;`};
                font-weight: 500;
                    ::before {
                        content: '';
                        display: inline-block;
                        width: 24px;
                        height: 30px;
                        margin-right: 10.5px;
                        background: url(/assets/images/icon/cart-info.svg) center center/auto no-repeat;
                        vertical-align: -9px;
                    }
                }
            .lineborder {
                height: 0;
                border-bottom: solid 1px #111111;
                margin-top: 11px;
            }
            .description {
                font-size: 14px;
                font-weight: normal;
                line-height: 1.86;
                color: #33333;
                padding-top: 9.9px;
                letter-spacing: -0.7px;
                .yellowblcok{
                    display: inline-block;
                    position: relative;
                }
                .yelline {
                    background-color: #ffe7ad;
                    /* ::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 7px;
                        height: 11px;
                        background-color: #ffe7ad;
                        z-index: -1;
                    } */
                }
            }
          }

        .infoview  {
            {display:unset; animation: fadeIn ease 1s;} 
        }

        

        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
              
    }

`;

const TriTest = styled.div`
    position: relative;
    z-index: 100;
   /* ::before, ::after{
    content: "";
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    height: 15px;
    width: 15px;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 43.9px;
    left: 124px;
    z-index: 100;
    background-color: #fff;
   
   } */

    width: 10px;
    height: 2px;
    background: #ffffff;

    position: absolute;
    ${isMobileOnly?`
    top: 27px;
    left: 102px;
    `:`
    bottom: -1px;
    left: 91px;
    `};

    :before {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(56deg);
        -moz-transform: rotate(56deg);
        -ms-transform: rotate(56deg);
        transform: rotate(56deg);
        position: absolute;
        top: -4px;
        right: -3px;
    }
    :after {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(-56deg);
        -moz-transform: rotate(-56deg);
        -ms-transform: rotate(-56deg);
        transform: rotate(-56deg);
        position: absolute;
        top: -4px;
        right: 2px;
    }

   @keyframes fadeIn {
    1000% {opacity:0;}
    100% {opacity:1;}
    }
    @keyframes fadeOut {
    1000% {opacity:1;}
    100% {opacity:0;}
    }

`;

// 면적 옵션
let areaOptions = [];

const placeOptions = [
    { value: -1, label: "주거형태를 선택하세요" },
    { value: 1, label: "원룸&오피스텔" },
    { value: 2, label: "아파트" },
    { value: 3, label: "빌라&연립" },
    { value: 4, label: "단독주택" },
    { value: 5, label: "사무공간" },
    { value: 6, label: "상업공간" },
    { value: 7, label: "기타" }
];

/**
 * 장바구니 견적 작성의 배송 정보
 */
const SrMyCartDvry = ({ postNumHandler, dateHandler,
    addrHandler, addr2Handler, areaTypeHandler, placeHandler,
    areaHandler, questionHandler, priceConfirmHandler, reffer = null ,handleFocus, handleBlur}) => {

    const dispatch = useDispatch();

    const [focused, setFocused] = useState(false);
    const [date, setDate] = useState(new Date());
    // const [date, setDate] = useState(moment().add(14, "days"));
    const [openModal, setOpenModal] = useState(false);
    const [postNum, setPostNum] = useState("");
    const [addr, setAddr] = useState("");
    const [area, setArea] = useState(0);
    const [place, setPlace] = useState(0);
    const [areaType, setAreaType] = useState(1);
    const [priceConfirm, setPriceConfirm] = useState(1);
    const [question, setQuestion] = useState("");
    const [addr2, setAddr2] = useState("");
    const [showInfoPopover, setShowInfoPopover] = useState(false); // 희망배송일 관련 안내문구 툴팁
    const [brndOption, setBrndOption] = useState([]);
    const [brandQuestion, setBrandQuestion] = useState([]);
    const [info, setInfo] = useState(false);
    const refInfo = useRef(null);
    const history = useHistory();
    // const calendarRef = useRef();

    // moment.locale('ko');

    const { accessToken, id, reqProdList  } = useSelector(
        ({ userReducer, userCartReducer, esItemsReducer }) => ({
            accessToken: userReducer.accessToken,
            reqProdList: userCartReducer.reqProdList,
            id: userReducer.id,
        })
    );

    useEffect(() => {
        if (areaOptions.length === 0) {
            let i = 5;
            
            let option = { value: -1, label: "면적을 선택하세요" };
            areaOptions.push(option);
            while (i < 56) {
                let option = { value: i, label: i + "평" };
                areaOptions.push(option)
                i++;
            }


        }

        var result = new Date();
        result.setDate(result.getDate() + 14);
        setDate(result);
        dateHandler(result.toISOString().slice(0, 19).replace('T', ' '));

        if(accessToken !== null){
            let addressStorage = localStorage.getItem('address');
            if(addressStorage !== null && addressStorage !== undefined){
                let address = DeCryptData(addressStorage);

                if(address !== undefined && address !== null && address.zipcode !== null && address.zipcode.length > 0
                    && address.addr1 !== null && address.addr1.length > 0
                    && address.addr2 !== null && address.addr2.length > 0 && address.id !== null && address.id.length > 0 && address.id === id){
                    setPostNum(address.zipcode);
                    postNumHandler(address.zipcode);
                    setAddr(address.addr1);
                    addrHandler(address.addr1);
                    setAddr2(address.addr2);
                    addr2Handler(address.addr2);
                }

            }
        }


    }, [])


    useEffect(() => {
        if(reqProdList !== null && reqProdList !== undefined) {
            let option = [];
            let opt = {};
            opt.value = -1;
            opt.label = '브랜드를 선택해주세요';
            option.push(opt);
            let opt1 = {};
            opt1.value = 1;
            opt1.label = '전체 브랜드';
            option.push(opt1);
            forEach(reqProdList, (curobj, index) => {
                if(curobj.list !== null && curobj.list.length > 0) {
                    let item = curobj.list[0];
                    let opt = {};
                    opt.value = item.brnd_id;
                    opt.label = item.brnd_nm;
                    option.push(opt);
                }
                
            });

            setBrndOption(option);

        }
    }, [reqProdList])

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (refInfo.current && !refInfo.current.contains(event.target)) {
                setInfo(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [refInfo]);

    // Date Picker 에서 날짜 변경
    const onDateChange = (date) => {
        let dateToday = new Date();
        let date1 = new Date(date)

        let diffDay = (dateToday.getTime()-date1.getTime())/(1000*60*60*24);

        if(diffDay > 0){
            return;
        }

        let strDate = date.toISOString().slice(0, 19).replace('T', ' ')
        setDate(date);
        // console.log(strDate);
        dateHandler(strDate);
    }

    // date picker 에서 포커서 변경
    const onFocusChange = (isFocused) => {
        setFocused(isFocused.focused);
    }

    // 주소 찾기
    const onOpenModal = () => {
        //console.log("test")
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    // 주소 찾기 완료
    const handleSearchComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        // console.log("data : " + JSON.stringify(data));
        setPostNum(data.zonecode);
        postNumHandler(data.zonecode);

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }

        setAddr(fullAddress);
        addrHandler(fullAddress);
        //history.goBack();
        onCloseModal();
    }

    const handleEsInfo = () => {
        setInfo(true);
    }

    // 평수 선택
    const handleAreaChange = (param) => {
        setArea(param.value);
        if(param.value*1 < 0) {
            areaHandler("0");
        } else {
            areaHandler(param.value + "평");
        }
    }

    // 주거형태 선택
    const handlePlaceChange = (param) => {
        setPlace(param.value);
        if(param.value*1 < 0) {
            placeHandler("0");
        } else {
            placeHandler("05530" + param.value);
        }
        
    }

    const handleAreaType = () => {
        areaTypeHandler("05520" + (areaType === 1 ? "0" : "1"));
        setAreaType(areaType === 1 ? 0 : 1);
    }

    // 설치 비용 확인
    const handlePriceConfirm = () => {
        setPriceConfirm(priceConfirm === 1 ? 0 : 1);
        priceConfirmHandler(priceConfirm === 1 ? 0 : 1);
    }

    const handleQuestionChange = (brnd_id, question, index) => {
        let _inQuestion = {brnd_id:brnd_id, question:question, index:index};

        let _brandQuestion = [];
        Object.assign(_brandQuestion,brandQuestion );
        let idx = findIndex(_brandQuestion, (curitem) => {
            return (curitem.index === index);
        })

        if(idx >= 0) {
            _brandQuestion[idx] = _inQuestion;
            
        } else {
            _brandQuestion.push(_inQuestion);
        }

        //console.log('handleQuestionChange = ' + JSON.stringify(_brandQuestion))
        setBrandQuestion(_brandQuestion);

        if(questionHandler !== undefined && questionHandler !== null) {
            questionHandler(_brandQuestion);
        }
    }

    const hanldeAddrInput = (e) => {
        setAddr2(e.target.value);
        addr2Handler(e.target.value);
    }

    const onFoucs = () => {
        if(handleFocus&&handleFocus!==undefined) {
            handleFocus();
        }
    }

    const onBlur = () => {
        if(handleBlur&&handleBlur!==undefined) {
            handleBlur();
        }
    }

    const CustomDateInput = ({ value, onClick })=>(
        <p className="p-re d-inline" onClick={onClick}>
            <input type="text" id="estimatedOrderDate" className="text-input"
                   style={isMobileOnly ? { "color": "rgb(51, 51, 51)"}:{"color": "rgb(51, 51, 51)" , width:'166px'}} value={value}/>
                <button type="button" className="calendar-btn input_item"/>
        </p>
    )

    const infoConcurrency = () => {return(
        <InfoPopOverBlock>
            <i className="fas fa-exclamation-circle" onClick={handleEsInfo} style={isMobileOnly? {marginLeft:'10px'}:{}}>
                {(<div className={info ? "info-concurrency infoview" :"info-concurrency"} ref={refInfo}>
                    <div className="title">희망 배송 일자 안내</div>
                    <div className="lineborder"></div>
                    <div className="description">
                        <div><div className="yellowblcok"><span className="yelline">확정된 날짜가 아닙니다.</span></div></div>
                        <p>희망 배송 일자이므로 업체와 상의 후 확정지으시길 바랍니다 :)</p>
                    </div>
                </div>)}
                
            </i>
        </InfoPopOverBlock>)
    }

    return (
        <SrMyCartDvryCompBlock>
            {isMobileOnly ?
                <div className="input-box margin_b-20">
                    <div className="margin_b-40">
                        {/* <p className="ess_text pink margin_b-10">
                            (필수) 배송정보에 따라 배송비가 차등 적용되기 때문에 중요해요
                      </p> */}
                        {/* <div className="input-title pink">희망 배송 일자</div> */}
                        <div style={{height: '33px'}}><TriTest style={info? {display: "block", animation:"fadeIn ease 1s" }:{display:"none"}}></TriTest>
                                                <label htmlFor="estimatedOrderDate1" className="input-title pink" style={{padding:'10px 0'}}>*희망 배송 일자<span style={{color:'#111111'}}>
                                                {infoConcurrency()}</span></label> </div>

                        <div style={{ height: "40px", display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                            <DatepickerBlock focused={focused}>
                                <DatePicker
                                    locale="ko"
                                    selected={date}
                                    onChange={onDateChange}
                                    dateFormat="yyyy.MM.dd (eee)"
                                    className="text-input item-input"
                                    style={{ width: '100%' }}
                                    customInput={<CustomDateInput/>}
                                />
                            </DatepickerBlock>
                            {/* <Tooltip placement="bottom" overlay={<div>※ 확정된 날짜가 아닙니다. <br />희망 배송 일자이므로 업체와 상의 후 확정 지으시길 바랍니다.</div>} trigger={['click']}>
                                <i className="fas fa-exclamation-circle fa-lg" />
                            </Tooltip> */}
                        </div>
                        <div className="info margin_t-10" style={{marginTop:'17px'}}>

                        </div>
                        <div className="input-title pink">*배송 지역</div>
                        <div>
                            <div className="address-finder">
                                <input type="text" className="text-input first" readOnly style={{ backgroundColor:'#f8f8f8' }} value={postNum} />
                                <button type="button" className="input_item gray-btn" onClick={onOpenModal}>주소 찾기</button>
                            </div>
                            <input type="text" className="text-input item-input2" readOnly placeholder="기본 배송 지역에 따라 배송비가 책정됩니다." style={{ "width": "100%", backgroundColor:'#f8f8f8'  }} value={addr} />
                            <NormalInput type="text" maxLength="65" marginBottom="40px"
                                placeholder="상세주소를 입력해주세요." marginInnerTop="10px"
                                onChange={hanldeAddrInput} dispError={false} defaultValue={addr2} inputRef={reffer} onFoucs={onFoucs} onBlur={onBlur}/>
                        </div>
                    </div>

                    <div>
                        {/* <p className="ess_text margin_b-10">
                            (선택) 판매자가 참고해서 조금 더 디테일한 견적을 낼 수 있어요.
                      </p> */}
                        <div className="input_title-box margin_b-20 clearfix">
                            <div className="input-title">설치 및 조립 요청</div>
                            <div className="delivery-input-item2">
                                <div  style={{float:'left', height:'30px', marginRight:'10px', marginTop:'-3px'}}>
                                    <CheckBtn onClick={handlePriceConfirm} defaultValue={priceConfirm}/>
                                </div>
                                <div  style={{float:'left', height:'30px', paddingTop:'3px', marginTop:'0px', fontSize:'13px', color:'#333333'}}>
                                비용 확인해주세요
                                </div>
                            </div>
                        </div>
                        <div className="input_title-box margin_b-20 clearfix">
                            <div className="input-title">주거형태</div>
                            <div className="delivery-input-item">
                                <div className="default-select select-box">
                                    <SelectDropDownBtn
                                        options={placeOptions}
                                        placeholder="주거형태를 선택하세요"
                                        handleFocus={onFoucs} 
                                        handleBlur={onBlur}
                                        onChange={handlePlaceChange} />
                                </div>
                            </div>
                        </div>
                        <div className="input_title-box margin_b-20 clearfix">
                            <div className="input-title">평수</div>
                            <div className="delivery-input-item">
                                <div className="double_btn-box w50">
                                    <button type="button" className={areaType === 1 ? "active" : ""} onClick={handleAreaType}>공급</button>
                                    <button type="button" className={areaType !== 1 ? "active" : ""} onClick={handleAreaType}>전용</button>
                                </div>
                                <div className="select-box">
                                    <SelectDropDownBtn
                                        options={areaOptions}
                                        placeholder="면적을 선택하세요"
                                        handleFocus={onFoucs} 
                                        handleBlur={onBlur}
                                        onChange={handleAreaChange} />
                                </div>
                            </div>
                        </div>
                        <div className="input_title-box clearfix">
                            <div className="input-title">문의사항</div>
                            <div className="select-box">
                            <div className="input-content f-left clearfix" style={{width:'100%'}}>
                            {
                                brndOption === null ? '' :
                                brndOption.map((item, idx) => {
                                    
                                    if(brandQuestion.length >= idx) {
                                        let option = [];
                                        //Object.assign(option, brndOption);
                                        forEach(brndOption, (curobj, index) => {
                                            let tObj = {};
                                            Object.assign(tObj, curobj);
                                            tObj.disabled = '';
                                            let _idx = findIndex(brandQuestion, (curitem) => {
                                                return (curitem.brnd_id === tObj.value);
                                            })
                                            if(_idx >= 0 && brandQuestion[_idx].brnd_id*1 >= 0) {
                                                tObj.disabled = 'yes';
                                            }

                                            option.push(tObj);
                                        });
                                        /* console.log("idx = " + JSON.stringify(idx))
                                        console.log("item.value = " + JSON.stringify(item.value))
                                        console.log("option = " + JSON.stringify(option))
                                        console.log("brandQuestion = " + JSON.stringify(brandQuestion))
                                        console.log("brndOption = " + JSON.stringify(brndOption)) */
                                        if(brndOption.length -1 > idx) {
                                            return <ReqFormQuestion key={item.value} options={option} questionHandler={handleQuestionChange} index={idx} handleFocus={onFoucs} 
                                            handleBlur={onBlur}></ReqFormQuestion>
                                        }
                                        
                                    }
                                    })
                            }
                            
                            {/* <TextArea placeholder="패키지 관련 문의 사항을 기입해주세요"
                                height="160px" onChange={handleQuestionChange} /> */}
                        </div>
                                {/* // <textarea className="input-textarea" style={{ "height": "160px" }} placeholder="패키지 관련 문의 사항을 기입해주세요"></textarea> */}
                            </div>
                        </div>
                    </div>
                </div>
                :
                <table className="table-info-box">
                    <tbody>
                        <tr>
                            <td className="border_bottom" style={{padding:'20px 36px'}}>
                                <div className="input-box margin_b-20">
                                    <div className="grid-2" style={{marginLeft:'0px'}}>
                                        <div className="grid-item"  style={{paddingLeft:'0px'}}>
                                            <p className="ess_text pink margin_b-10">(필수) 배송정보에 따라 배송비가 차등 적용되기 때문에 중요해요. 꼭 입력해주세요.</p>
                                            <div className="input_title-box  clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <TriTest style={info? {display: "block", animation:"fadeIn ease 1s" }:{display:"none"}}></TriTest>
                                                <label htmlFor="estimatedOrderDate1" className="input-title f-left pink" style={{padding:'10px 0'}}>희망 배송 일자 <span style={{color:'#111111'}}>
                                                {infoConcurrency()}</span></label> 
                                                <div className="input-content f-left">
                                                    <div className="clearfix" style={{ height: "40px" }}>
                                                        <DatepickerBlock focused={focused}>
                                                            <DatePicker
                                                                locale="ko"
                                                                selected={date}
                                                                onChange={onDateChange}
                                                                dateFormat="yyyy.MM.dd (eee)"
                                                                className="text-input item-input"
                                                                customInput={<CustomDateInput/>}
                                                            />
                                                        </DatepickerBlock>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input_title-box clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <label htmlFor="hopeShipping" className="input-title f-left pink" style={{padding:'10px 0'}}>배송 지역</label>
                                                <div>
                                                    <div className="input-content f-left">
                                                        <input type="text" className="text-input first f-left" readOnly style={{ "width": "80px", backgroundColor:'#f8f8f8' }} value={postNum} />
                                                        <button type="button" className="input_item gray-btn" onClick={onOpenModal} style={{ zIndex: "2", width:'80px', height:'40px', fontSize:'14px' }}>주소 찾기</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input_title-box clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <label htmlFor="hopeShipping" className="input-title f-left pink" style={{padding:'10px 0'}}></label>
                                                <div>
                                                    <div className="input-content f-left">
                                                        <div className="item_input-box">
                                                            <input type="text" className="text-input item-input2" readOnly placeholder="기본 배송 지역에 따라 배송비가 책정됩니다." style={{ "width": "347px", backgroundColor:'#f8f8f8', padding:'0 15px 0 15px' }} value={addr} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input_title-box clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <label htmlFor="hopeShipping" className="input-title f-left pink" style={{padding:'10px 0'}}></label>
                                                <div>
                                                    <div className="input-content f-left">
                                                        <NormalInput type="text" maxLength="65" marginBottom="0px"
                                                            placeholder="상세주소를 입력해주세요." width="347px" float="right" marginInnerTop="0px"
                                                            onChange={hanldeAddrInput} dispError={false} defaultValue={addr2}
                                                            inputRef={reffer} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                  
                                            
                                        <div className="grid-item" style={{paddingLeft:'56px'}}>
                                            <p className="ess_text margin_b-10">(선택) 판매자가 참고해서 조금 더 디테일한 견적을 낼 수 있어요.</p>
                                            <div className="input_title-box  clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <span className="input-title f-left" style={{padding:'10px 0'}}>설치 및 조립 요청</span>
                                                <div className="input-content f-left clearfix">
                                                <div className="input-title f-left clearfix" style={{margin: '0 auto', width:'fit-content', height:'40px'}}>
                                                    <div  style={{float:'left', height:'30px', marginRight:'10px', marginTop:'-10px'}}>
                                                        <CheckBtn onClick={handlePriceConfirm} defaultValue={priceConfirm}/>
                                                    </div>
                                                    <div  style={{float:'left', height:'30px', paddingTop:'3px', marginTop:'-7px'}}>
                                                    비용 확인해주세요
                                                    </div>
                                                    
                                                </div>
                                                    {/* <div className="double_btn-box">
                                                        <button type="button" className={priceConfirm === 1 ? "active" : ""} onClick={handlePriceConfirm}>비용 확인해주세요</button>
                                                        <button type="button" className={priceConfirm !== 1 ? "active" : ""} onClick={handlePriceConfirm}>비용 확인하지 않습니다</button>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="input_title-box  clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <span className="input-title f-left" style={{padding:'10px 0'}}>주거형태</span>
                                                <div className="input-content f-left clearfix">
                                                    <div className="default-select" style={{width:'360px'}}>
                                                        <SelectDropDownBtn
                                                            options={placeOptions}
                                                            placeholder="주거형태를 선택하세요"
                                                            onChange={handlePlaceChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input_title-box  clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                    <span className="input-title f-left" style={{padding:'10px 0'}}>평수</span>
                                                    <div className="input-content f-left clearfix">
                                                        <div className="double_btn-box f-left" style={{ width: "170px" }}>
                                                            <button type="button" className={areaType === 1 ? "active" : ""} onClick={handleAreaType} style={{width:'80px',borderRadius:'4px', marginRight:'10px', border: '1px solid #ccc'}}>공급</button>
                                                            <button type="button" className={areaType !== 1 ? "active" : ""} onClick={handleAreaType} style={{width:'80px',borderRadius:'4px', }}>전용</button>
                                                        </div>
                                                        <div className="default-select f-left margin_l-10" style={{ width: "180px" }}>
                                                            <SelectDropDownBtn
                                                                options={areaOptions}
                                                                placeholder="면적을 선택하세요"
                                                                onChange={handleAreaChange} />
                                                        </div>
                                                    </div>
                                            </div>
                                            <div className="input_title-box clearfix" style={{position:'relative', height:'60px', padding:'10px 0'}}>
                                                <span className="input-title f-left" style={{padding:'10px 0'}}>문의사항</span>
                                                <div className="input-content f-left clearfix">
                                                    {
                                                        brndOption === null ? '' :
                                                        brndOption.map((item, idx) => {
                                                            
                                                            if(brandQuestion.length >= idx) {
                                                                let option = [];
                                                                //Object.assign(option, brndOption);
                                                                forEach(brndOption, (curobj, index) => {
                                                                    let tObj = {};
                                                                    Object.assign(tObj, curobj);
                                                                    tObj.disabled = '';
                                                                    let _idx = findIndex(brandQuestion, (curitem) => {
                                                                        return (curitem.brnd_id === tObj.value);
                                                                    })
                                                                    if(_idx >= 0 && brandQuestion[_idx].brnd_id*1 >= 0) {
                                                                        tObj.disabled = 'yes';
                                                                    }

                                                                    option.push(tObj);
                                                                });
                                                                /* console.log("idx = " + JSON.stringify(idx))
                                                                console.log("item.value = " + JSON.stringify(item.value))
                                                                console.log("option = " + JSON.stringify(option))
                                                                console.log("brandQuestion = " + JSON.stringify(brandQuestion))
                                                                console.log("brndOption = " + JSON.stringify(brndOption)) */
                                                                if(brndOption.length -1 > idx) {
                                                                    return <ReqFormQuestion key={item.value} options={option} questionHandler={handleQuestionChange} index={idx}></ReqFormQuestion>
                                                                }
                                                            }
                                                         })
                                                    }
                                                    
                                                    {/* <TextArea placeholder="패키지 관련 문의 사항을 기입해주세요"
                                                        height="160px" onChange={handleQuestionChange} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }



            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={daumModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <DaumPostcode
                    onComplete={handleSearchComplete}  autoClose={true} submitMode={false}/>
            </Modal>


        </SrMyCartDvryCompBlock >

    );
};

export default SrMyCartDvry;
